import React from 'react';
import axios from 'axios';
import { Link, withRouter } from 'react-router-dom';
import Pagination from '../../component/Pagination';
import AlertLabel from '../../component/AlertLabel';
import { Field, reduxForm } from 'redux-form';
import {  RenderSearchForm } from '../../component/formInput';
import { StringUtils } from '../../utils/javascriptUtils';
import ProductSelect from '../../component/ProductSelect';
import ProductModal from './modal/ProductModal';

var _ = require('lodash');

function ProductRows(data, handleShowModal){
  const inner_rows = _.map(data, (i, index) => {
    return <tr key={index}>
        <td>{i.name}</td>
        <td>{i.code}</td>
        <td>{i.product_type}</td>
        <td>{i.level}</td>
        <td>{i.point}</td>
        <td>
          <div className="icons-list">
            <div className="dropdown">
              <a href="#" className="list-icons-item" data-toggle="dropdown">
                <i className="icon-menu9"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <a onClick={()=> handleShowModal(i)} className="dropdown-item">
                  <i className="icon-pencil"></i> Chỉnh sửa
              </a>
              </div>
            </div>
          </div>
        </td> 
      </tr>
  })
  return inner_rows;
}

class ProductTable extends React.Component {
  constructor(props) {
    super(props);
    const {product_type} = this.props.routeProps.match.params;
    this.state = {
      table_data: [],
      table_query: {
        current_page: 1,
        number_of_row: 20,
        product_type: product_type,
        search_field: "search",
        search_value: "",
        alert_label: null,
      },
      product_selected: null,
      is_show_modal: false
    }
  }

  componentDidMount() {
    this.listReload(this.state.table_query);
  }

  gotoPage = (page) => {
    const table_query = {
      ...this.state.table_query,
      current_page: page
    };
    this.listReload(table_query);
  }
  
  // Lấy danh sách sản phẩm  
  listReload = (table_query) => {
    const self = this;
    axios({
      method: 'post',
      url: window.api_url + '/admin/api/product/list',
      withCredentials: true,
      data: table_query
    }).then(function (response) {
      self.setState({
        ...self.state,
        table_query: table_query,
        table_data: response.data.data
      })
    });
  }
  
  handleShowModal = (product) => {
    this.setState({
      is_show_modal: true,
      product_selected: product
    })
  }

  handleHideModal = () => {
    this.setState({
      is_show_modal: false,
      product_selected: null
    })
    this.listReload(this.state.table_query)
  }

  onProductSelect = (product_type) => {
    const { history } = this.props;
    const table_query = {
      ...this.state.table_query,
      product_type: product_type
    };
    this.listReload(table_query)
  }

  onSearchSubmit = (values) => {
    const search_value = values.search ? values.search : "";
    const { history } = this.props;
    const table_query = {
      ...this.state.table_query,
      search_value: search_value,
      current_page: 1,
      invoice_status: "all"

    };
    history.push("/admin/product/list?search=" + search_value);
    this.listReload(table_query);
  }

  clearDataFilter = () => {
    const { reset, history } = this.props;
    const self = this;
    const table_query = {
      ...this.state.table_query,
      search_value: "",
      current_page: 1
    };
    reset();
    history.push("/admin/product/list");
    this.listReload(table_query);
  }
  
  onKeyPess = (key_code) => {
    if (key_code == "Escape") {
      this.clearDataFilter();
    }
  }

  render() {
    const { handleSubmit } = this.props;
    const {table_query, table_data, alert_label, is_show_modal, product_selected} = this.state;
    return(
      <React.Fragment> 
        <div className="page-header">
          <h4>
            <i className="icon-paragraph-justify2"></i>
            <span className="text-semibold"> Danh sách sản phẩm</span>
          </h4>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card card-body">
              <form style={{display:"inline-flex"}} onSubmit={handleSubmit(this.onSearchSubmit)}>
                <div style={{ width:"100%", paddingRight:5}}>
                  <Field
                    name="search"
                    placeholder="Tìm kiếm: Tên sản phẩm hoặc mã sản phẩm."
                    defaultValue = {table_query.search_value}
                    onKeyAction={(ev)=> this.onKeyPess(ev)}
                    component={RenderSearchForm}
                  />
                </div>
              </form>
            </div>
            {/* TODO: */}
            {/* <button onClick={()=>this.handleShowModal()} className="btn bg-primary" style={{float: "right"}}>+ Thêm Mới</button> */}
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            {alert_label && <AlertLabel status = {alert_label.status} message = {alert_label.message}/>}
            <div className="card">
              <div className="table-responsive">
                <table className="table table-togglable table-hover default footable-loaded footable">
                  <thead>
                    <tr>
                      <th>Tên</th>
                      <th>Mã</th>
                      <th>Phân Loại</th>
                      <th>Level</th>
                      <th>Point</th>
                      <th className="text-center footable-visible footable-last-column" style={{width: "30px"}}>
                        <i className="icon-menu-open2"></i>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {table_data && ProductRows(table_data.data, this.handleShowModal)}
                  </tbody>
                </table>
              </div>
            </div>
            <Pagination query={table_query} data={table_data} handle={this.gotoPage}/>
          </div>
          {is_show_modal && <ProductModal productObj={product_selected} show={is_show_modal} onHide={this.handleHideModal} />}
        </div>
      </React.Fragment>
    )
  }
}

const ProductTableWrapper = reduxForm({
  form: 'ProductTable',
  destroyOnUnmount: true,
  enableReinitialize: true,
})(ProductTable);

export default withRouter(ProductTableWrapper);